import { render, staticRenderFns } from "./mobiledeliverylist.vue?vue&type=template&id=1241cf47&"
import script from "./mobiledeliverylist.vue?vue&type=script&lang=js&"
export * from "./mobiledeliverylist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports